!function(e,o){"object"==typeof exports&&"object"==typeof module?module.exports=o():"function"==typeof define&&define.amd?define([],o):"object"==typeof exports?exports.storeblocks=o():e.storeblocks=o()}(self,(()=>(()=>{"use strict";var e={n:o=>{var r=o&&o.__esModule?()=>o.default:()=>o;return e.d(r,{a:r}),r},d:(o,r)=>{for(var t in r)e.o(r,t)&&!e.o(o,t)&&Object.defineProperty(o,t,{enumerable:!0,get:r[t]})},o:(e,o)=>Object.prototype.hasOwnProperty.call(e,o),r:e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})}},o={};e.r(o),e.d(o,{BoxBase:()=>s});const r=require("styled-components");var t=e.n(r);const n=require("styled-system"),s=t().div.attrs({className:"box"})`
  display: flex;
  box-sizing: border-box;

  color: ${({color:e})=>`var(--color-${e})`};
  background: ${({background:e})=>`var(--color-${e})`};

  ${n.layout}
  ${n.space}
  ${n.border}
  ${n.flexbox}
  ${n.position}
  ${n.shadow}
  ${n.fontSize}
`;return o})()));
//# sourceMappingURL=styled.js.map